<bic-popup (close)="cancelClicked()" customClass="w-[560px]" title="Einige Dateien konnten nicht hochgeladen werden">
  <div bicPopupContent class="flex flex-col gap-4">
    @if (unsupportedTypeGroups.length > 0) {
      <div class="flex flex-col gap-2">
        <span class="text-sm text-gray font-medium underline">Nicht unterstützte Dateiformate:</span>
        @for (group of unsupportedTypeGroups; track group.extension) {
          <div class="flex flex-col gap-1">
            <span class="text-sm text-gray font-medium">.{{ group.extension }} ({{ group.count }} Datei{{ group.count !== 1 ? 'en' : '' }})</span>
            <ul class="text-sm text-gray list-disc list-inside">
              @for (name of group.preview; track name) {
                <li>{{ name }}</li>
              }
              @if (group.hiddenCount > 0) {
                <li class="italic">… und {{ group.hiddenCount }} weitere</li>
              }
            </ul>
          </div>
        }
      </div>
    }
    @if (tooLargeGroups.length > 0) {
      <div class="flex flex-col gap-2">
        <span class="text-sm text-gray font-medium underline">Datei zu groß:</span>
        @for (group of tooLargeGroups; track group.extension) {
          <div class="flex flex-col gap-1">
            <span class="text-sm text-gray font-medium">.{{ group.extension }} ({{ group.count }} Datei{{ group.count !== 1 ? 'en' : '' }})</span>
            <ul class="text-sm text-gray list-disc list-inside">
              @for (name of group.preview; track name) {
                <li>{{ name }}</li>
              }
              @if (group.hiddenCount > 0) {
                <li class="italic">… und {{ group.hiddenCount }} weitere</li>
              }
            </ul>
          </div>
        }
      </div>
    }
    @if (data.validCount > 0) {
      <span class="text-sm text-gray">Alle anderen ausgewählten Dateien werden hochgeladen.</span>
    } @else {
      <span class="text-sm text-gray">Es konnte keine der ausgewählten Dateien hochgeladen werden.</span>
    }
  </div>
  <div bicPopupButtonGroup class="flex flex-row w-full justify-end gap-4">
    <bic-button (onClick)="cancelClicked()" buttonType="white">Schließen</bic-button>
  </div>
</bic-popup>
